// Math helpers used across factor-pipeline submodules.

/** Coerce NaN/Infinity/null to null; pass-through otherwise. */
export function safe(n: number | undefined | null): number | null {
  if (n == null || !isFinite(n) || isNaN(n)) return null;
  return n;
}

/** Compound annual growth rate over N years. Returns null if invalid. */
export function cagr(start: number | null, end: number | null, years: number): number | null {
  if (!start || !end || start <= 0 || years <= 0) return null;
  return safe(Math.pow(end / start, 1 / years) - 1);
}

/** Signed growth for cases where CAGR fails (negative base or end values).
 *  Handles turnarounds (neg→pos) and deteriorations (pos→neg). */
export function signedGrowth(start: number | null, end: number | null): number | null {
  if (start == null || end == null || start === 0) return null;
  return safe((end - start) / Math.abs(start));
}

/** Population stddev over a numeric array. Requires ≥3 observations. */
export function stdDev(vals: number[]): number | null {
  if (vals.length < 3) return null;
  const mean = vals.reduce((a, b) => a + b, 0) / vals.length;
  return Math.sqrt(vals.reduce((a, b) => a + (b - mean) ** 2, 0) / vals.length);
}
